/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {BaseAnimationRenderer as ɵangular_packages_platform_browser_animations_animations_f} from './src/animation_renderer';
export {BROWSER_ANIMATIONS_PROVIDERS as ɵangular_packages_platform_browser_animations_animations_d,BROWSER_NOOP_ANIMATIONS_PROVIDERS as ɵangular_packages_platform_browser_animations_animations_e,instantiateDefaultStyleNormalizer as ɵangular_packages_platform_browser_animations_animations_b,instantiateRendererFactory as ɵangular_packages_platform_browser_animations_animations_c,instantiateSupportedAnimationDriver as ɵangular_packages_platform_browser_animations_animations_a} from './src/providers';